import React, { useState } from "react";
import {
  applyCategoryTemplateToModels,
  copyCategoryTemplate,
} from "../../services/assessmentApi";

const AssessmentTemplateActions = ({ categories, categoryId, onDone, compact = false }) => {
  const [copyFromId, setCopyFromId] = useState("");
  const [busy, setBusy] = useState("");
  const [message, setMessage] = useState("");

  if (!categoryId) return compact ? null : <p className="field-hint">Select a category.</p>;

  const categoryName = categories.find((c) => String(c.id) === String(categoryId))?.name || "category";

  const handleCopy = async () => {
    if (!copyFromId || String(copyFromId) === String(categoryId)) return alert("Pick a different source category");
    setBusy("copy");
    try {
      const r = await copyCategoryTemplate(copyFromId, categoryId);
      setMessage(`Copied ${r.questionsCreated} Q, ${r.defectsCreated} D`);
      onDone?.();
    } catch (err) {
      alert(err.message);
    } finally {
      setBusy("");
    }
  };

  const handleApply = async (mode) => {
    if (!window.confirm(`${mode === "replace" ? "Replace" : "Merge"} category template onto all models in ${categoryName}?`)) return;
    setBusy(mode);
    try {
      const r = await applyCategoryTemplateToModels(categoryId, { mode });
      setMessage(`Applied to ${r.modelsAffected} model(s)`);
      onDone?.();
    } catch (err) {
      alert(err.message);
    } finally {
      setBusy("");
    }
  };

  return (
    <div className="admin-card" style={compact ? { padding: "12px 14px", marginBottom: 12 } : undefined}>
      <h3 style={compact ? { fontSize: "1rem" } : undefined}>Category template shortcuts</h3>
      <div className="admin-filters" style={{ flexWrap: "wrap", gap: 8 }}>
        <select value={copyFromId} onChange={(e) => setCopyFromId(e.target.value)} disabled={!!busy}>
          <option value="">Copy from category…</option>
          {categories.filter((c) => String(c.id) !== String(categoryId)).map((c) => (
            <option key={c.id} value={c.id}>{c.name}</option>
          ))}
        </select>
        <button type="button" className="admin-btn secondary" disabled={!copyFromId || !!busy} onClick={handleCopy}>Copy here</button>
        <button type="button" className="admin-btn secondary" disabled={!!busy} onClick={() => handleApply("merge")}>Apply merge</button>
        <button type="button" className="admin-btn" disabled={!!busy} onClick={() => handleApply("replace")}>Apply replace</button>
      </div>
      {message && <p className="success-msg">{message}</p>}
    </div>
  );
};

export default AssessmentTemplateActions;
